import { MuiButton } from '@/components/button/MuiButton';
import {
  Box,
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  Typography,
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { useLogic } from './logic';
import { api_portalOfficeHospitalListing_responseFilter } from '@/init/swagger';
import { Fragment } from 'react';

type Props = {
  hospitalAppealPoints: api_portalOfficeHospitalListing_responseFilter[];
  search: () => Promise<void>;
  close: () => void;
};

export function AppealPointsContent({
  hospitalAppealPoints,
  search,
  close,
}: Props) {
  const { items, toggle, onClear, onSubmit } = useLogic({
    hospitalAppealPoints,
    search,
    close,
  });

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Typography variant="JP/Heading/m/Bold/Tight" sx={{ flex: 1 }}>
          アピールポイントで絞る
        </Typography>

        <MuiButton variant="text" sx={{ color: '#000' }} onClick={close}>
          とじる
          <ClearIcon />
        </MuiButton>
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '20% 1fr',
          alignItems: 'baseline',
          rowGap: 2,
        }}
      >
        <Typography
          variant="JP/Body/m/Medium/Tight"
          sx={{
            gridRow: 1,
            gridColumn: 1,
            '@media (max-width: 880px)': {
              gridRow: 1,
              gridColumn: '1 / span 2',
            },
          }}
        >
          アピールポイント
        </Typography>

        <Box
          sx={{
            gridRow: 1,
            gridColumn: 2,
            '@media (max-width: 880px)': {
              gridRow: 2,
              gridColumn: '1 / span 2',
            },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',
              flexWrap: 'wrap',
              flexGrow: 1,
              rowGap: 2,
              columnGap: 3,
              maxWidth: '100%',
            }}
          >
            {items.map(({ id, label, checked }) => {
              return (
                <Fragment key={id}>
                  {id != null && (
                    <FormGroup
                      sx={{
                        backgroundColor: 'bg.lighter',
                        alignItems: 'center',
                      }}
                    >
                      <FormControlLabel
                        label={label}
                        style={{
                          marginLeft: '0rem',
                          marginRight: 2,
                        }}
                        control={
                          <Checkbox
                            checked={checked}
                            onChange={(e) => toggle(e, id)}
                            name={label}
                            sx={{ p: 0 }}
                          />
                        }
                      />
                    </FormGroup>
                  )}
                </Fragment>
              );
            })}
          </Box>
        </Box>
      </Box>

      <Divider />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'end',
          my: 2,
          gap: 1,
        }}
      >
        <MuiButton color="primary" variant="text" onClick={onClear}>
          選択中のフィルターをクリア
        </MuiButton>

        <MuiButton color="primary" onClick={onSubmit}>
          検索
        </MuiButton>
      </Box>
    </>
  );
}
